import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { APP_PRIMENG_MODULE } from '../utils/ngprime-packages';
import { TransviewComponent } from './transview/transview.component';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { CardComponent } from './card/card.component';
import { AudioComponentComponent } from './audio-component/audio-component.component';
import { AudioRecorderComponent } from './audio-recorder/audio-recorder.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AudioPlayerCustomComponent } from './audio-player-custom/audio-player-custom.component';
import { TranslateWidgetComponent } from './translate-widget/translate-widget.component';
import { UploadComponent } from './upload/upload.component';
import { LoaderComponent } from './loader/loader.component';

@NgModule({
  declarations: [
    NavbarComponent,
    AudioPlayerComponent,
    CardComponent,
    TransviewComponent,
    AudioComponentComponent,
    AudioRecorderComponent,
    AudioPlayerCustomComponent,
    TranslateWidgetComponent,
    UploadComponent,
    LoaderComponent
  ],
  imports: [
    CommonModule,
    APP_PRIMENG_MODULE,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports:[
    CommonModule,
    NavbarComponent,
    AudioPlayerComponent,
    CardComponent,
    AudioRecorderComponent,
    APP_PRIMENG_MODULE,
    FormsModule,
    ReactiveFormsModule,
    AudioPlayerCustomComponent,
    TransviewComponent,
    AudioComponentComponent,
    TranslateWidgetComponent,
    UploadComponent,
    LoaderComponent
  ]
})
export class WidgetsModule { }